<script setup lang="js">
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import { useRouteParams } from '@vueuse/router';
import { useInputGeometryCatalogsStore } from '@/stores/inputGeometryCatalogs.store';
import { useProjectStore } from '@/stores/project.store';

const { closeModal } = useModal();
const inputGeoCatalogStore = useInputGeometryCatalogsStore();
const projectStore = useProjectStore();
const projectId = useRouteParams('projectId');
const bpId = useRouteParams('bpId');
const bpNodeId = useRouteParams('nodeId');
const nodeOpenStates = ref({});
const checkedGeoCatalog = ref({});
const selectAllChecked = ref(false);
const { project } = storeToRefs(projectStore);
const { ancestorNodesList, viewGeometryCatalogList, createViewGeometryCatalogRequest } = storeToRefs(inputGeoCatalogStore);

onMounted(() => {
  inputGeoCatalogStore
    .getAncestorNodesList(projectId.value, bpId.value, bpNodeId.value)
    .then(() => {
      if (viewGeometryCatalogList.value && viewGeometryCatalogList.value.length > 0) {
        viewGeometryCatalogList.value.forEach((geom) => {
          checkedGeoCatalog.value[geom.input_geo_catalog.id] = true;
        });
      }
    });
});

function toggleNode(bpNodeId) {
  nodeOpenStates.value[bpNodeId] = !nodeOpenStates.value[bpNodeId];
}
function toggleAll() {
  Object.keys(nodeOpenStates.value).forEach((key) => {
    nodeOpenStates.value[key] = false;
  });
}
function selectAll() {
  const newState = selectAllChecked.value;
  ancestorNodesList.value.forEach((ancestor) => {
    ancestor.input_geo_catalogs.forEach((geom) => {
      checkedGeoCatalog.value[geom.id] = newState;
    });
  });
}
function getTitle(title) {
  return title[project.value.default_locale];
}
function create() {
  const creating_input_geo_catalog_ids = [];
  const removing_input_geo_catalog_ids = [];
  ancestorNodesList.value.forEach((ancestor) => {
    ancestor.input_geo_catalogs.forEach((geom) => {
      const wasSelected = geom.id in checkedGeoCatalog.value;
      if (checkedGeoCatalog.value[geom.id]) {
        const existsInViewDocuments = viewGeometryCatalogList.value.some(
          (viewGeom) => viewGeom.input_geo_catalog.id === geom.id
        );
        if (!existsInViewDocuments) {
          creating_input_geo_catalog_ids.push(geom.id);
        }
      } else {
        if (wasSelected) {
          removing_input_geo_catalog_ids.push(geom.id);
        }
      }
    });
  });
  inputGeoCatalogStore
    .createViewGeometryCatalogs(
      projectId.value,
      bpId.value,
      bpNodeId.value,
      creating_input_geo_catalog_ids,
      removing_input_geo_catalog_ids
    )
    .then(() => {
      closeModal();
    });
}
function isRequestError() {
  return createViewGeometryCatalogRequest.value.error;
}
</script>

<template>
  <ModalTemplateSide @submit="create" :disableButtons="createViewGeometryCatalogRequest.isLoading">
    <template v-slot:title>Добавить гео каталог для просмотра</template>
    <template v-slot:body>
      <p v-if="isRequestError()" class="error-mesage">
        {{ isRequestError() }}
      </p>
      <div class="d-flex justify-content-between">
        <div class="form-label d-flex align-items-center">
          <input type="checkbox" class="me-3 modal-checkbox" v-model="selectAllChecked" @change="selectAll" />Выделить
          все
        </div>
        <div class="form-label" @click="toggleAll">
          Свернуть все
          <img src="@/assets/img/minus-ico-with-border.svg" class="ms-3" />
        </div>
      </div>
      <div class="d-flex justify-content-between flex-column" v-for="ancestor in ancestorNodesList" :key="ancestor.id">
        <div class="modal-nodes d-flex justify-content-between">
          <span> {{ ancestor.current.node.name }}</span>
          <img src="@/assets/img/plus-ico-with-border.svg" @click="toggleNode(ancestor.current.id)"
            v-if="!nodeOpenStates[ancestor.current.id]" />
          <img src="@/assets/img/minus-ico-with-border.svg" @click="toggleNode(ancestor.current.id)"
            v-if="nodeOpenStates[ancestor.current.id]" />
        </div>
        <div v-if="nodeOpenStates[ancestor.current.id]" class="node-docs">
          <div class="d-flex justify-content-between">
            <span>Название гео каталога</span>
          </div>
          <div v-for="inputGeom in ancestor.input_geo_catalogs" :key="inputGeom.id"
            class="node-doc-list d-flex align-items-start mt-3">
            <input type="checkbox" v-model="checkedGeoCatalog[inputGeom.id]" class="me-1 modal-checkbox" />
            <span>{{ getTitle(inputGeom.geo_catalog.title) }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:submit>Добавить</template>
  </ModalTemplateSide>
</template>
